import React from 'react';
import { Fragment, useState, useEffect } from 'react';
import { Row, Alert, Col } from 'react-bootstrap';
import FormBusca from './form_busca';
import ProjetoCulturalService from '../../../services/projetoCultural'
import Projeto from './projeto';

const ListarProjetos = () => {


    const [projetos, setProjetos] = useState([]);
    const [vazio, setVazio] = useState(false);

    async function fetchProjetos() {
        const response = await ProjetoCulturalService.listar();
        if (response.data.length >= 1) {
            setProjetos(response.data)
            setVazio(false)
        } else {
            setProjetos([])
            setVazio(true)
        }
    }

    useEffect(() => {
        fetchProjetos();
    }, []);


    return (
        <Fragment>
            <Fragment>
                <FormBusca
                    setProjetos={setProjetos}
                    setVazio={setVazio}
                    fetchProjetos={fetchProjetos}
                    projetos={projetos}
                />
            </Fragment>
            {vazio ? <Fragment>
                <Alert variant='danger'>Nenhum recurso foi captado e direcionado para qualquer projeto cultural ou esportivo no Município de Macuco, não gerando com isso renúncia de receita.</Alert>
            </Fragment> :
                <Fragment>
                    <h5>Projetos Culturais/Esportivos com recursos de patrocinadores/doadores no Município de Macuco:</h5><br />
                    <Row xs={12} lg={3}>
                        {projetos.map((projeto, index) =>
                            <Projeto
                                projeto={projeto}
                                key={index}
                            />
                        )}
                    </Row>
                </Fragment>}
        </Fragment>

    )
}

export default ListarProjetos;